import { getIsBffFeatureEnabled } from '@/helpers/getIsBffFeatureEnabled';

import { OidcCheckAuthorized } from './OidcCheckAuthorized';
import { SessionCheckAuthorized } from './SessionCheckAuthorized';

const CheckAuthorized = () => {
  if (getIsBffFeatureEnabled()) {
    return <SessionCheckAuthorized />;
  }

  return <OidcCheckAuthorized />;
};

export default CheckAuthorized;
